import { Draggable } from 'devextreme-react';
import { SelectBox } from 'devextreme-react/select-box';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import api from '../../../services/api-configuration';
import { getAllWarehouses } from '../../../services/apis';
import PopoverInfoIcon from '../../../utils/PopoverInfoIcon';
import useFormatMessage from '../../../utils/useFormatMessage';

const AdresIslemleri = ({ selected, isOpen, setIsOpen, setTrigger, trigger }) => {
    const { t } = useFormatMessage();
    const notifyError = (message) => toast.error(message);
    const notify = (message) => toast.success(message);

    const [warehouses, setWarehouses] = useState([]);
    const [zones, setZones] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);

    useEffect(() => {
        const fetchWarehouses = async () => {
            if (isOpen) {
                try {
                    setSelectedWarehouse(selected?.warehouse_id);
                    // Fetch warehouses when modal opens
                    const response = await getAllWarehouses();
                    setWarehouses(response);
                } catch (err) {
                    console.error("Error fetching warehouses:", err);
                }
            }
        };

        fetchWarehouses(); // Async fonksiyonu çağırıyoruz
        // eslint-disable-next-line
    }, [isOpen]);


    const handleWarehouseChange = (e) => {
        setSelectedWarehouse(e);
        // Fetch zones for selected warehouse
        const response = api.post('/zone/getZonesByWarehouse', {
            warehouse_id: e
        });
        response.then((res) => {
            let all_data = res.data.data || []
            setZones(
                all_data.filter(x =>
                    // zone_name "SANAL" ifadesini içermeyen bölge isimlerini getir includes("SANAL") false döner
                    !x.zone_name.includes("SANAL")


                )
            );
        }).catch((err) => {
            notifyError(t("Bölge Listesi Alınırken hata oluştu"));
            console.error(err);
        });
    };

    const InputField = ({ title, id, children, type, value, className = "" }) => {
        return (
            <Col lg="12" className={className}>
                <div className="dx-fieldset p-0 m-1">
                    <div className="dx-field">
                        <div className="dx-field-label" style={{ color: "black" }}>
                            <span className='d-flex align-items-center'>
                                {t(title)} &nbsp;
                                {title === "Kapasite" &&

                                    <PopoverInfoIcon
                                        index={1}
                                        textInfoBreak={`
                                            Bir sırada oluşturulacak adres sayısını belirler. 'br'
                                        Örnek: Eğer 'Sıra' 1-3 ve 'Kapasite' 3 olarak seçilirse, 'br' her bir sırada 3 adres olmak üzere toplamda 9 adres oluşturulur.
                                            `}
                                        text={""}
                                    />
                                }
                            </span>

                        </div>
                        <div className="dx-field-value d-flex">
                            {children ? children : (
                                <Input
                                    id={id}
                                    type={type || "text"}
                                    defaultValue={value && selected[value]}
                                    min={type === "number" ? 0 : null}
                                    placeholder={`${t('please')} ${t(title)} ${t('enter')} ...`}
                                    onChange={(e) => {
                                        if (id === "sira-start" || id === "sira-end" || id === "kapasite"
                                        ) {
                                            let start = Number(document.getElementById("sira-start").value)
                                            let end = Number(document.getElementById("sira-end").value)
                                            let capacity = Number(document.getElementById("kapasite").value)
                                            if (start && end && capacity) {
                                                let totalAdress = (end - start + 1) * capacity
                                                document.querySelector('.total-adress-count').innerText = totalAdress

                                            }


                                        }
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>


            </Col>
        );
    };

    const validateForm = () => {
        const warehouseId = document.getElementById("depo-adi-select").childNodes[0].childNodes[0].value;
        const zoneId = document.getElementById("bolge-adi-select")?.childNodes[0].childNodes[0].value;
        const koordinant = document.getElementById("koordinant").value;
        const yon = document.getElementById("yon").value;
        //const sira = document.getElementById("sira-end").value;
        const kapasite = document.getElementById("kapasite").value;

        if (!warehouseId) {
            notifyError(t("Depo Adı") + " " + t("Boş Olamaz"));
            return false;
        }
        if (!zoneId) {
            notifyError(t("Bölge Adı") + " " + t("Boş Olamaz"));
            return false;
        }
        if (!koordinant) {
            notifyError(t("Koordinant") + " " + t("Boş Olamaz"));
            return false;
        }
        if (!yon) {
            notifyError(t("Yön") + " " + t("Boş Olamaz"));
            return false;
        }
        if (document.getElementById("sira-start").value === "" || document.getElementById("sira-end").value === "") {
            notifyError(t("Sıralar") + " " + t("Boş Olamaz"));
            return false;
        }
        if (parseInt(document.getElementById("sira-start").value) > parseInt(document.getElementById("sira-end").value)) {
            notifyError(t("Başlangıç Sırası Bitiş Sırasından Büyük Olamaz"));
            return false;
        }
        if (!kapasite) {
            notifyError(t("Kapasite") + " " + t("Boş Olamaz"));
            return false;
        }

        return true;
    };

    const handleSubmit = () => {
        if (!validateForm()) {
            return;
        }
        addNewAddress();
    };

    const addNewAddress = async () => {

        let body = {
            "capacity": parseInt(document.getElementById("kapasite").value),
            "coordinate": document.getElementById("koordinant").value,
            "create_user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
            "direction": document.getElementById("yon").value,
            "end_seq": parseInt(document.getElementById("sira-end").value),
            "start_seq": parseInt(document.getElementById("sira-start").value),
            "warehouse_id": parseInt(document.getElementById("depo-adi-select").childNodes[0].childNodes[0].value),
            "zone_id": parseInt(document.getElementById("bolge-adi-select").childNodes[0].childNodes[0].value),
        }
        const response = api.post('/adress/add', body)
        response.then((res) => {
            notify(t("Adres Ekleme Başarılı"))
            setIsOpen(!isOpen)
            setTrigger(!trigger)
        }).catch((err) => {
            let errorMessage = err.response?.data?.error
            // sequence range 1-5 already exists for coordinate A and direction B
            if (errorMessage.includes("sequence range") && errorMessage.includes("already exists for coordinate") && errorMessage.includes("and direction")) {
                notifyError(t("Bu koordinat ve yön için belirtilen sıra aralığı zaten mevcut"))
                return
            }

            const message = t("Adres Ekleme Başarısız") + ": " + t(errorMessage[0])

            if (err.response?.data?.error) {
                if (errorMessage[1]) {
                    notifyError(message + " ID: " + t(errorMessage[1]))
                } else {
                    notifyError(message)
                }
                return
            }
            notifyError(t("Adres Ekleme Başarısız"))
        })


    }


    return (
        <Draggable handle='.modal-header'>
            <Modal size="lg" isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
                <ModalHeader className='modal-header' toggle={() => setIsOpen(!isOpen)}>{t("Adres İşlemleri")}</ModalHeader>
                <ModalBody>
                    <Row>
                        <InputField title="Depo Adı" id="depo-adi">
                            <SelectBox
                                id='depo-adi-select'
                                className="w-100"
                                dataSource={warehouses}
                                displayExpr="warehouse_name"
                                valueExpr="id"
                                value={selectedWarehouse}
                                onValueChange={(e) => {
                                    handleWarehouseChange(e)
                                }}
                            />
                        </InputField>

                        <InputField title="Bölge Adı" id="bolge-adi">
                            <SelectBox
                                className="w-100"
                                id='bolge-adi-select'
                                dataSource={zones}
                                displayExpr="zone_name"
                                valueExpr="id"
                                defaultValue={selected?.zone_id}
                            />
                        </InputField>

                        <InputField title="Koordinant" id="koordinant" value="coordinate" />
                        <InputField title="Yön" id="yon" value="direction" />
                        <InputField title="Sıra" id="sira" type="number" value="row" >
                            <Row>
                                <Col>
                                    <Input
                                        id="sira-start"
                                        type="number"
                                        defaultValue={selected["row"]}
                                        min={0}
                                        placeholder={`${t('please')} ${t("Sıra")} ${t('enter')} ...`}
                                        onChange={(e) => {

                                            let start = Number(document.getElementById("sira-start").value)
                                            let end = Number(document.getElementById("sira-end").value)
                                            let capacity = Number(document.getElementById("kapasite").value)
                                            if (start && end && capacity) {
                                                let totalAdress = (end - start + 1) * capacity
                                                document.querySelector('.total-adress-count').innerText = totalAdress

                                            }
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        id="sira-end"
                                        type="number"
                                        defaultValue={selected["row"]}
                                        min={0}
                                        placeholder={`${t('please')} ${t("Sıra")} ${t('enter')} ...`}

                                        onChange={(e) => {

                                            let start = Number(document.getElementById("sira-start").value)
                                            let end = Number(document.getElementById("sira-end").value)
                                            let capacity = Number(document.getElementById("kapasite").value)
                                            if (start && end && capacity) {
                                                let totalAdress = (end - start + 1) * capacity
                                                document.querySelector('.total-adress-count').innerText = totalAdress

                                            }
                                        }}
                                    />
                                </Col>

                            </Row>
                        </InputField>
                        <div>

                        </div>
                        <InputField title="Kapasite" id="kapasite" type="number" value="capacity" />


                        <InputField title={""} id={"total-adress"} type="number">
                            <div className="d-flex align-items-center mt-3" style={{ color: "#333", fontSize: "16px" }}>
                                <i className="fas fa-map-marker-alt me-2" style={{ color: "#007BFF" }}></i>
                                <span className="me-2">{t("Toplam Oluşturulan Adres")}:</span> &emsp;
                                <b className="total-adress-count" style={{ color: "red", fontSize: "18px" }}>
                                    0
                                </b>
                            </div>

                        </InputField>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={handleSubmit}>{t("Kaydet")}</Button>
                    <Button color="danger" onClick={() => setIsOpen(!isOpen)}>{t("İptal")}</Button>
                </ModalFooter>
            </Modal>
        </Draggable>
    );
};

export default AdresIslemleri;